import React, { useState } from 'react';
import DataTable from 'react-data-table-component';
import {
    Check,
    X,
    Trash2,
    Eye,
    Download,
    FileText,
    Search
} from 'lucide-react';
import SidebarAdmin from './superdashboard/SideBarAdmin';
import MobileNavigationAdmin from './superdashboard/MobileNavigationAdmin';
import DashboardHeaderAdmin from './superdashboard/DashboardHeaderAdmin';
import AdminMenu from '../components/AdminMenu';

const InformationsVoyageur = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const [filterText, setFilterText] = useState('');

    const voyageurs = [
        {
            id: 1,
            nom: 'Amadou Ibrahim',
            email: 'amadou@email.com',
            motif: 'Affaires',
            duree: '8-14 jours',
            ville_destination: 'Niamey',
            date_depart: '2024-04-01',
            status: 'En attente',
            telephone: '+227 90 XX XX XX',
            num_passeport: 'A123456'
        },
        {
            id: 2,
            nom: 'Mariama Diallo',
            email: 'mariama@email.com',
            motif: 'Tourisme',
            duree: '15-30 jours',
            ville_destination: 'Agadez',
            date_depart: '2024-04-15',
            status: 'Validé',
            telephone: '+227 91 XX XX XX',
            num_passeport: 'B789012'
        }
    ];

    const columns = [
        {
            name: 'Nom',
            selector: row => row.nom,
            sortable: true,
        },
        {
            name: 'Contact',
            cell: row => (
                <div>
                    <div>{row.email}</div>
                    <div className="text-sm text-gray-500">{row.telephone}</div>
                </div>
            ),
            sortable: true,
        },
        {
            name: 'N° Passeport',
            selector: row => row.num_passeport,
            sortable: true,
        },
        {
            name: 'Motif',
            selector: row => row.motif,
            sortable: true,
        },
        {
            name: 'Durée',
            selector: row => row.duree,
        },
        {
            name: 'Destination',
            selector: row => row.ville_destination,
            sortable: true,
        },
        {
            name: 'Date départ',
            selector: row => row.date_depart,
            sortable: true,
        },
        {
            name: 'Statut',
            cell: row => (
                <span className={`px-2 py-1 text-xs rounded-full ${
                    row.status === 'Validé' 
                        ? 'bg-green-100 text-green-800'
                        : row.status === 'Rejeté'
                        ? 'bg-red-100 text-red-800'
                        : 'bg-yellow-100 text-yellow-800'
                }`}>
                    {row.status}
                </span>
            ),
            sortable: true,
        },
        {
            name: 'Actions',
            cell: row => (
                <div className="flex gap-2">
                    {row.status === 'En attente' && (
                        <>
                            <button 
                                className="p-1 hover:bg-green-50 rounded text-green-600"
                                onClick={() => handleValidate(row.id)}
                                title="Valider"
                            >
                                <Check className="w-4 h-4" />
                            </button>
                            <button 
                                className="p-1 hover:bg-red-50 rounded text-red-600"
                                onClick={() => handleReject(row.id)}
                                title="Rejeter"
                            >
                                <X className="w-4 h-4" />
                            </button>
                        </>
                    )}
                    <button 
                        className="p-1 hover:bg-blue-50 rounded text-blue-600"
                        onClick={() => handleView(row.id)}
                        title="Voir détails"
                    >
                        <Eye className="w-4 h-4" />
                    </button>
                    <button 
                        className="p-1 hover:bg-red-50 rounded text-red-600"
                        onClick={() => handleDelete(row.id)}
                        title="Supprimer"
                    >
                        <Trash2 className="w-4 h-4" />
                    </button>
                </div>
            ),
        },
    ];

    const handleValidate = (id) => {
        console.log('Validate:', id);
    };

    const handleReject = (id) => {
        console.log('Reject:', id);
    };

    const handleView = (id) => {
        console.log('View:', id);
    };

    const handleDelete = (id) => {
        console.log('Delete:', id);
    };

    const exportToCSV = () => {
        const csvContent = [
            ["Nom", "Email", "Téléphone", "N° Passeport", "Motif", "Durée", "Destination", "Date départ", "Statut"],
            ...voyageurs.map(v => [
                v.nom,
                v.email,
                v.telephone,
                v.num_passeport,
                v.motif,
                v.duree,
                v.ville_destination,
                v.date_depart,
                v.status
            ])
        ].map(e => e.join(",")).join("\n");

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "voyageurs.csv");
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const filteredItems = voyageurs.filter(
        item => {
            const searchText = filterText.toLowerCase();
            return (
                item.nom.toLowerCase().includes(searchText) ||
                item.email.toLowerCase().includes(searchText) ||
                item.num_passeport.toLowerCase().includes(searchText)
            );
        }
    );

    const customStyles = {
        table: {
            style: {
                backgroundColor: 'white',
                borderRadius: '0.5rem',
            },
        },
        headRow: {
            style: {
                backgroundColor: '#f9fafb',
                borderBottomWidth: '1px',
                borderBottomColor: '#e5e7eb',
                minHeight: '3.5rem',
            },
        },
        rows: {
            style: {
                minHeight: '3.5rem',
                fontSize: '0.875rem',
                '&:hover': {
                    backgroundColor: '#f9fafb',
                    cursor: 'pointer',
                },
            },
        },
        pagination: {
            style: {
                borderTopWidth: '1px',
                borderTopColor: '#e5e7eb',
            },
            pageButtonsStyle: {
                borderRadius: '0.375rem',
                height: '2rem',
                width: '2rem',
                padding: '0.25rem',
                margin: '0 0.25rem',
                cursor: 'pointer',
                transition: '0.2s',
                color: '#437011',
                fill: '#437011',
                '&:disabled': {
                    cursor: 'unset',
                    color: '#cbd5e1',
                    fill: '#cbd5e1',
                },
            },
        },
    };

    return (
        <div className="flex min-h-screen bg-[#F4F8E9]">
            <SidebarAdmin
                isOpen={isSidebarOpen}
                menuItems={AdminMenu}
                onClose={() => setIsSidebarOpen(false)}
            />

            <div className="flex-1">
                <DashboardHeaderAdmin
                    isSidebarOpen={isSidebarOpen}
                    setIsSidebarOpen={setIsSidebarOpen}
                />

                <main className="max-w-7xl mx-auto px-4 sm:px-6 py-4 sm:py-8 pb-20 lg:pb-8">
                    <div className="mb-6 flex justify-between items-center">
                        <div>
                            <h1 className="text-2xl font-bold text-[#437011]">
                                Liste des Voyageurs
                            </h1>
                            <p className="text-gray-600">
                                Gérez les demandes de voyage
                            </p>
                        </div>
                        <div className="flex gap-2">
                            <button 
                                onClick={exportToCSV}
                                className="flex items-center gap-2 px-4 py-2 border border-[#437011] text-[#437011] rounded-lg hover:bg-[#437011] hover:text-white transition-colors"
                            >
                                <FileText className="w-4 h-4" />
                                Export CSV
                            </button>
                            <button 
                                onClick={() => console.log('Export Excel')}
                                className="flex items-center gap-2 px-4 py-2 bg-[#437011] text-white rounded-lg hover:bg-[#2F5000] transition-colors"
                            >
                                <Download className="w-4 h-4" />
                                Export Excel
                            </button>
                        </div>
                    </div>

                    <div className="bg-white rounded-lg shadow p-4">
                        <div className="mb-4 w-72">
                            <div className="relative">
                                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                                <input
                                    type="text"
                                    placeholder="Rechercher un voyageur..."
                                    className="w-full pl-10 pr-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#437011]"
                                    value={filterText}
                                    onChange={e => setFilterText(e.target.value)}
                                />
                            </div>
                        </div>

                        <DataTable
                            columns={columns}
                            data={filteredItems}
                            pagination
                            paginationPerPage={10}
                            customStyles={customStyles}
                            highlightOnHover
                            pointerOnHover
                        />
                    </div>
                </main>

                <MobileNavigationAdmin menuItems={AdminMenu} />
            </div>
        </div>
    );
};

export default InformationsVoyageur;